<template>
    <div>
        <app-form-select-input
            v-if="!isClient"
            label="Tipo consigna"
            :options="type"
            v-model="duty.dutyTypeId"
            :is-object="false"
            :hasError="$v.duty.dutyTypeId.$error"
            errorMessage="Debe seleccionar el tipo de consigna"
            @change="$v.duty.dutyTypeId.$touch()"
            :required="true"
        />
        <app-form-textarea-input
            label="Descripción"
            :required="true"
            v-model="duty.description"
            :hasError="$v.duty.description.$error"
            errorMessage="Debe escribir la descripción"
        />
    </div>
</template>
<script>
import dutiesRepository from "../../../repositories/duties.repository.js";
import FormTextInput from "../../UI/Controls/Forms/FormTextInput.vue";
import FormSelectInput from "../../UI/Controls/Forms/FormSelectInput.vue";
import FormTextareaInput from "../../UI/Controls/Forms/FormTextareaInput.vue";
import { required } from "vuelidate/lib/validators";
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        theClientId: {
            default: ""
        },
        myDuty: {
            default: null
        },
        onSave: {
            type: Function
        }
    },
    components: {
        appFormTextInput: FormTextInput,
        appFormTextareaInput: FormTextareaInput,
        appFormSelectInput: FormSelectInput
    },

    data() {
        return {
            duty: {
                description: "",
                clientId: "",
                dutyTypeId: "",
                approvedById: ""
            },
            isClient: false,
            type: [
                { id: 1, name: "General" },
                { id: 0, name: "Especifica" }
            ]
        };
    },

    validations() {
        let duty;
        if (!this.isClient) {
            duty = {
                description: { required },
                dutyTypeId: { required }
            };
        } else {
            duty = {
                description: { required }
            };
        }
        return { duty };
    },

    watch: {
        myDuty(val) {
            this.fillForm();
        }
    },
    methods: {
        saveDuty() {
            this.duty.clientId = this.theClientId;
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            if (!this.typeDuty && !this.theClientId) {
                this.duty.approvedById = this.user.id;
            }

            const dr = Object.assign({}, dutiesRepository);
            dr.saveDuty(this.duty)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrio un error al guardar la consigna");
                });
        },
        updateDuty() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const payload = { ...this.duty, userId: this.user.id };

            const dr = Object.assign({}, dutiesRepository);
            dr.updateDuty(payload, this.myDuty.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrio un error al actualizar la consigna");
                });
        },
        saveOrUpdate() {
            if (!!this.myDuty) {
                this.updateDuty();
            } else {
                this.saveDuty();
            }
        },
        fillForm() {
            if (Object.keys(this.myDuty).length !== 0) {
                this.duty.dutyTypeId = this.clientId ? 0 : this.myDuty.general;
                this.duty.description = this.myDuty.description;
                this.duty.clientId = !!this.theClientId ? this.theClientId : "";
            } else {
                this.cleanFields();
            }
        },
        cleanFields() {
            Object.keys(this.duty).map(key => (this.duty[key] = ""));
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },

    created() {
        this.$bus.$on(`${this.id}.save`, this.saveOrUpdate);
        this.$bus.$on(`${this.id}.clean`, this.cleanFields);
        this.isClient =
            this.user.profile.slug === "cliente-admin" ? true : false;
        this.cleanFields();
    },

    beforeDestroy() {
        this.$bus.$off(`${this.id}.save`);
    }
};
</script>
